module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 9.6 15.1\" enable-background=\"new 0 0 9.6 15.1\" xml:space=\"preserve\"><polygon class=\"control-svg\" fill=\"#000111\" points=\"9.6,7.5 0,15.1 0,0 \"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/icons/play.svg
// module id = 845
// module chunks = asvp